import React from "react";
import { Box, Heading, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from "@chakra-ui/react";
import LearnReact from "./LearnReact";
import ReactCourse from "./ReactCourse";
import TestReact from "./TestReact";
import LearnJava from "./LearnJava";
import InternLearn from "./InternLearnChaptered";
import InternTest from "./InternTest";

const LearningDashboard = () => {
  return (
    <Box>
      <Box px={6} pt={6} pb={2}>
        <Heading size="lg">Learning Dashboard</Heading>
        <Text color="gray.600" mt={1}>
          Switch between courses and practice modules.
        </Text>
      </Box>
      <Tabs variant="enclosed" colorScheme="blue" isLazy>
        <Box px={6}>
          <TabList>
            <Tab>React Course</Tab>
            <Tab>Learn React</Tab>
            <Tab>React Test</Tab>
            <Tab>Learn Java</Tab>
            <Tab>Intern Learn</Tab>
            <Tab>Intern Test</Tab>
          </TabList>
        </Box>
        <TabPanels>
          <TabPanel px={0} pt={4}>
            <ReactCourse />
          </TabPanel>
          <TabPanel px={0} pt={4}>
            <LearnReact />
          </TabPanel>
          <TabPanel px={0} pt={4}>
            <TestReact />
          </TabPanel>
          <TabPanel px={0} pt={4}>
            <LearnJava />
          </TabPanel>
          <TabPanel px={0} pt={4}>
            <InternLearn />
          </TabPanel>
          <TabPanel px={0} pt={4}>
            <InternTest />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default LearningDashboard;
